/**
 * The attendance a screen may praise.
 *
 * 75% because that is the minimum most Indian boards set for sitting the
 * final exam — below it a family is being warned, not praised. One constant
 * because the overview card and the profile tab each used to pick their own
 * bar, and a child at 72% was told "Good Effort" on one and nothing good on
 * the other.
 */
export const GOOD_ATTENDANCE_PERCENT = 75;
